export default __webpack_public_path__ + "static/media/0363.cc4bead6.jpg";